import styled, { css } from "styled-components";
import { getColor } from "../themeHandler";

interface ModalContainerProps {
  readonly modalTheme: string;
  readonly size: string;
  readonly isSectionModal?: boolean;
  readonly isMobile: boolean;
  readonly memberOnlyGrayBar?: boolean;
  readonly hasBorder?: boolean;
  readonly borderColor?: string;
  readonly roundedCorners?: boolean;
}

export const StyledModalContainer = styled.div<ModalContainerProps>`
  background-color: ${(props) => getColor(props.modalTheme, 'modalBackgroundColor')};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  width: 100%;
  max-width: ${(props) => (props.isSectionModal ? "65%" : "40%")};
  min-height: ${(props) => handlerModalSize(props.size)};
  border-radius: ${(props) => (props.roundedCorners ? "5px" : "0")};
  font-size: 0.75em;
  padding: 0.875em;

  > div > img {
    max-height: 80px;
  }

  ${(props) =>
    props.memberOnlyGrayBar &&
    css`
      padding-bottom: 30px;
    `}

  ${(props) =>
    props.isMobile &&
    css`
      min-height: 20em;
      max-width: 90%;
      font-size: 1em;
    `}

  ${(props) =>
    props.hasBorder &&
    css`
      border: 5px solid ${getColor(props.modalTheme, 'borderColor')};
    `}
`;

const handlerModalSize = (size: string) => {
  switch (size) {
    case "sm":
      return "80%";

    case "md":
      return "23em";
  }
};

StyledModalContainer.defaultProps = {};
